import { jsx } from 'react/jsx-runtime';
import { twMerge } from 'tailwind-merge';
import { smallIcons, mediumIcons, largeIcons, socialIcons } from './SystemIcon.constants.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
/**
 * 시스템 아이콘을 표시하는 컴포넌트입니다.
 * 크기별(small, medium, large) 및 소셜 아이콘을 지원합니다.
 *
 * @param {Object} props - 컴포넌트 속성
 * @param {string} props.name - 아이콘의 이름 (예: 'small_close', 'medium_check', 'large_arrow')
 * @param {string} [props.testId] - 테스트를 위한 ID
 * @param {string} [props.className] - 추가적인 CSS 클래스
 * @param {boolean} [props.solid=false] - 아이콘을 실선으로 표시할지 여부
 * @param {Function} [props.onClick] - 클릭 이벤트 핸들러
 *
 * @example
 * // 기본 사용법
 * <SystemIcon name="small_close" />
 *
 * // 커스텀 클래스와 함께 사용
 * <SystemIcon
 *   name="medium_check"
 *   className="text-blue-500"
 *   solid={true}
 * />
 *
 * // 클릭 이벤트와 함께 사용
 * <SystemIcon
 *   name="large_arrow"
 *   onClick={() => console.log('아이콘 클릭됨')}
 *   testId="arrow-icon"
 * />
 */ const SystemIcon = ({ name, testId, className, solid = false, onClick })=>{
    const sizeOfIcon = name.split('_')[0];
    const modifiedClassName = twMerge('text-w-gray-900', className);
    const IconComponent = (props)=>{
        if (sizeOfIcon === 'small') {
            const Icon = smallIcons.get(name);
            return Icon && /*#__PURE__*/ jsx(Icon, _object_spread({}, props));
        }
        if (sizeOfIcon === 'medium') {
            const Icon = mediumIcons.get(name);
            return Icon && /*#__PURE__*/ jsx(Icon, _object_spread({}, props));
        }
        if (sizeOfIcon === 'large') {
            const Icon = largeIcons.get(name);
            return Icon && /*#__PURE__*/ jsx(Icon, _object_spread({}, props));
        }
        const Icon = socialIcons.get(name);
        return Icon && /*#__PURE__*/ jsx(Icon, _object_spread({}, props));
    };
    return IconComponent && /*#__PURE__*/ jsx(IconComponent, {
        className: modifiedClassName,
        testId: testId,
        solid: solid,
        onClick: onClick
    });
};

export { SystemIcon as default };
